<template>
    <div @click.stop>
        <label class="flex group" :class="[disabled ? 'cursor-not-allowed' : 'cursor-pointer', slotBefore ? 'justify-end' : '', labelClass, checkboxAlignmentClass]">
            <input type="checkbox" class="hidden border-none" :checked="isChecked" @change="toggle" :disabled="disabled">
            <span v-if="$slots.default && slotBefore" class="flex-1 pr-8 first-letter:uppercase text-black" :class="spanClass">
                <slot></slot>
            </span>
            <span
                class="toggle w-16 h-16 border rounded-4 box-content inline-flex items-center justify-center"
            >
                <svg-icon
                    v-if="isChecked && !indeterminate"
                    class="w-16 h-16 fill-white"
                    type="check"
                />
                <div v-if="indeterminate" class="h-2 w-8 bg-white"></div>
            </span>
            <span v-if="$slots.default && !slotBefore" class="flex-1 pl-8 first-letter:uppercase grow text-start text-black" :class="spanClass">
                <slot></slot>
            </span>
        </label>
    </div>
</template>

<script>
import SvgIcon from "../ui/SvgIcon";
    export default {
        model: {
            prop: 'checked',
            event: 'change',
        },
        components: {
            SvgIcon
        },
        props: {
            value: {},
            checked: {},
            spanClass: {
                type: String,
                default: ''
            },
            labelClass: String,
            disabled: Boolean,
            slotBefore: Boolean,
            checkboxAlignment: {
                type: String,
                default: 'center'
            },
            indeterminate: Boolean,
        },
        computed: {
            isChecked() {
                return Array.isArray(this.checked) ? this.checked.includes(this.value) : this.checked;
            },
            checkboxAlignmentClass() {
                return this.checkboxAlignment === 'top' ? 'items-start' : 'items-center';
            },
        },
        methods: {
            toggle(event) {
                if (this.disabled)
                    return;

                let checked = this.checked;

                if (Array.isArray(this.checked)) {
                    if (event.target.checked) {
                        checked = [...checked, ...[this.value]];
                    } else {
                        checked.splice(checked.indexOf(this.value), 1);
                    }
                } else {
                    checked = event.target.checked;
                }

                this.$emit('change', checked);
            }
        }
    }
</script>

<style scoped>
input[type='checkbox'] {
    &:checked:not(:disabled) ~ .toggle {
        @apply bg-secondary border-secondary;
    }
    &:disabled ~ .toggle {
        @apply border-primary-40;
    }
    &:checked:disabled ~ .toggle {
        @apply bg-primary-40 border-primary-40;
    }
    &:not(:checked):not(:disabled) {
        &  ~ .toggle {
            @apply border-primary;
        }
        &:hover ~ .toggle {
            @apply bg-primary-60 border-primary-80;
        }
    }
}
</style>
